import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React from 'react';
import { calculateCpsCplEnglish, calculateCpsCplLanguage, generateClassNames } from './CpsCplHighlighting';
import SubtitleTimeField from './SubtitleTimeField';

const SubtitleTimeSection = ({
    rowData,
    index,
    currentIndex,
    viewEng,
    checkSub,
    handleKeyDown,
    updateSub,
    startField,
    endField,
    startValue,
    endValue,
}) => {
    let cpsCplValue;

    if (startField === 'Estart' || endField === 'Eend') {
        cpsCplValue = calculateCpsCplEnglish(rowData, viewEng);
    } else {
        cpsCplValue = calculateCpsCplLanguage(rowData, viewEng);
    }

    return (
        <div
            className={generateClassNames({ rowData, index }, currentIndex, viewEng, checkSub)}
            style={{
                width: '150px',
                textAlign: 'center',
                paddingTop: '5px',
                fontSize: '12px',
            }}
        >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <SubtitleTimeField
                    value={startValue}
                    onKeyDown={handleKeyDown}
                    field={startField}
                    index={index}
                    updateSub={updateSub}
                    rowData={rowData}
                />
                <span className="content">-</span>
                <SubtitleTimeField
                    value={endValue}
                    onKeyDown={handleKeyDown}
                    field={endField}
                    index={index}
                    updateSub={updateSub}
                    rowData={rowData}
                />
                <span className="content ss">seconds</span>
                <span className="cps_cpl">{cpsCplValue}</span>
            </LocalizationProvider>
        </div>
    );
};

export default SubtitleTimeSection;
